import helper from '@/libs/forms';


export default {
  fields: [
    helper.currency('Amount', 'amount', true),
    helper.simpleInput('text', 'Borrower Name', null, 'borrowerName', true),
    helper.simpleInput('text', 'Account Number', null, 'accountNumber', false),
  ],
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/financial/assets/schemas/accountsNotes.js